import React from "react";
import { Phone, MessageCircle } from "lucide-react";

const WaterproofingCTA: React.FC = () => {
  return (
    <section className="max-w-7xl mx-auto px-6 py-16 flex flex-col md:flex-row gap-8 justify-center md:justify-between">
      
      {/* Call Expert */}
      <div className="flex-1 bg-amber-50 p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all cursor-pointer transform hover:-translate-y-1">
        <div className="flex items-center gap-3 mb-4">
          <Phone className="text-amber-600 w-8 h-8" />
          <h3 className="text-gray-800 font-bold text-lg">
            Call our <span className="text-amber-600">Expert for Waterproofing Queries</span>
          </h3>
        </div>
        <p className="text-gray-700 font-semibold text-2xl mb-6">+91 7291832000</p>
        <a
          href="tel:+917291832000"
          className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-500 to-amber-600 text-white px-6 py-3 rounded-xl font-semibold hover:from-amber-600 hover:to-amber-700 transition-all shadow-md hover:shadow-lg"
        >
          Call Now
        </a>
      </div>

      {/* WhatsApp Expert */}
      <div className="flex-1 bg-green-50 p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all cursor-pointer transform hover:-translate-y-1">
        <div className="flex items-center gap-3 mb-4">
          <MessageCircle className="text-green-600 w-8 h-8" />
          <h3 className="text-gray-800 font-bold text-lg">
            Chat with our <span className="text-green-600">SmartCare expert for waterproofing advice</span>
          </h3>
        </div>
        <p className="text-gray-700 text-sm mb-6">
          Say "Hi" to <span className="font-semibold">+91 7291832000</span>
        </p>
        <a
          href="https://wa.me/917291832000"
          target="_blank"
          className="inline-flex items-center gap-2 bg-gradient-to-r from-green-500 to-green-600 text-white px-6 py-3 rounded-xl font-semibold hover:from-green-600 hover:to-green-700 transition-all shadow-md hover:shadow-lg"
        >
          Chat on WhatsApp
        </a>
      </div>

    </section>
  );
};

export default WaterproofingCTA;
